/* eslint-disable max-len */
const NS = 'ShopItemsWidget';
const CLS = 'shopItemsWidget';
const CLS_IS_SELECTED = 'is-selected';
const CLS_HIDE = 'd-none';
const CLS_DISABLED = 'disabled';
const OFFSET_TOP = 100;

import utils from '../utils';
import _ from 'lodash';

export class ShopItemsWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.api = this.$element.data('api');
		this.$items = this.$element.find(`.${CLS}-items`);
		this.$dropdowns = this.$element.find(`.${CLS}-dropdowns .dropdown`);
		this.$dropdownItems = this.$dropdowns.find('.dropdown-item');
		this.$menu = this.$element.find(`.${CLS}-menu`);
		this.$filters = this.$element.find(`.${CLS}-filters`);
		this.$loadMoreWrap = this.$element.find(`.${CLS}-loadMoreWrap`);
		this.$loadMoreBtn = this.$element.find(`.${CLS}-loadMoreBtn`);
		this.$sortDropdown = this.$element.find(`.${CLS}-sortDropdown`);
		this.$clearFilterBtn = this.$element.find(`.${CLS}-clearFilterBtn`);

		this.sourceId = this.$element.data('source-id');
		this.shopName = this.$element.data('shop-name');

		// https://stackoverflow.com/questions/8898412/iphone-ipad-triggering-unexpected-resize-events
		// iOS safari trigeered unexpected resize event. Need to store window width
		this.windowWidth = $(window).width();

		this.params = {
			pageNumber: 1,
		};

		this.urlPattern = {};

		this.initDropdowns();
		this.initFilters();
		this.initStickyFilter();
		this.moveDropdown();
		this.updateParam();
		this.handleResize();
		this.handleClearFilter();
		this.initProductItemWidget();
	}

	initDropdowns() {
		this.$dropdownItems.on('click', (event) => {
			event.preventDefault();
			let $element = $(event.currentTarget);
			let filterType = $element.parents(`.dropdown`).attr('data-filter-type');
			let $parent = $element.parents('.dropdown');
			let filterValue = $element.attr('data-filter-value') || '';

			$parent.find('.dropdown-item').removeClass(CLS_IS_SELECTED);
			$element.addClass(CLS_IS_SELECTED);
			this.params[filterType] = filterValue;
			this.params['pageNumber'] = 1;
			this.updateUrl();
		});
	}

	initFilters() {
		this.$filterItemHeader = this.$filters.find(`.${CLS}-filter-header`);
		this.$filterRadio = this.$filters.find(`.${CLS}-filter-body-item-radio`);
		let animationDuration = 400;

		// Util function to rotate the filterHeaderIcon
		let rotateIcon = (item, initialDegree = 0, degree = 180, animate = true) => {
			let $element = item.children(`.${CLS}-filter-header-icon`);

			if (animate) {
				$({ deg: initialDegree }).animate({ deg: degree }, {
					duration: animationDuration,
					step: (now) => {
						$element.css({
							transform: `rotate(${now}deg)`,
						});
					}
				});
			}
			else {
				$element.css({
					transform: `rotate(${degree}deg)`,
				});
			}
		};

		this.$filterItemHeader.on('click', (event) => {
			let $element = $(event.currentTarget);
			$(document.body).trigger('sticky_kit:recalc');

			if ($element.parents(`.${CLS}-filter`).attr('data-active') === 'true') {
				rotateIcon($element, 180, 0);
				$element.next(`.${CLS}-filter-body`).slideUp({
					duration: animationDuration,
					complete: () => {
						$element.parents(`.${CLS}-filter`).attr('data-active', false);
					},
				});
			}
			else {
				rotateIcon($element, 0, 180);
				$element.next(`.${CLS}-filter-body`).slideDown({
					duration: animationDuration,
					complete: () => {
						$element.parents(`.${CLS}-filter`).attr('data-active', true);
					},
				});
			}
		});

		this.$filterRadio.on('click', (event) => {
			let $element = $(event.currentTarget);
			let filterType = $element.parents(`[data-filter-type]`).attr('data-filter-type');
			let value = $element.val();

			if(_.isNil(filterType)) {
				console.error(`${NS}::Error`, 'Please ensure there is a filterType value in the data-filter-type-attribute');
				return;
			}

			if(this.params[filterType] === value) {
				$element.prop('checked', false);
				this.urlPattern[filterType] = null;
			}
			else {
				this.urlPattern[filterType] = value;
			}

			if(_.isNil(this.urlPattern[filterType]) || this.urlPattern[filterType] === '') {
				delete this.urlPattern[filterType];
			}

			this.params['pageNumber'] = 1;
			this.updateUrl();
		});

		this.$filterToggler = this.$element.find(`.${CLS}-filterToggler`);

		this.$filterToggler.on('click', () => {
			if(this.$filters.attr('data-concealed') === 'true') {
				this.$filters.slideDown({
					duration: animationDuration,
					complete: () => {
						this.$filters.attr('data-concealed', false);
						this.$filterToggler.attr('data-concealed', false);
					},
				});
			}
			else {
				this.$filters.slideUp({
					duration: animationDuration,
					complete: () => {
						this.$filters.attr('data-concealed', true);
						this.$filterToggler.attr('data-concealed', true);
					},
				});
			}
		});

		let concealFilter = () => {
			if(utils.checkBP('ds')) {
				this.$filters.attr('data-concealed', true);
				this.$filterToggler.attr('data-concealed', true);
				this.$filters.hide();
			}
			else {
				this.$filters.attr('data-concealed', false);
				this.$filterToggler.attr('data-concealed', false);
				this.$filters.show();
			}
		};

		$(window).on('resize', _.debounce(() => {
			if (this.windowWidth !== $(window).width()) {
				this.windowWidth = $(window).width();
				concealFilter();
			}
		}, 50));

		concealFilter();
	}

	handleResize() {
		$(window).on('resize', _.debounce(() => {
			this.initStickyFilter();
			this.moveDropdown();
		}, 150));
	}

	initStickyFilter() {
		if (utils.checkBP('ds', true)) {
			this.$filters.stick_in_parent({
				parent: `.${CLS}`,
				offset_top: OFFSET_TOP
			});
		} else {
			this.$filters.trigger('sticky_kit:detach');
		}
	}

	moveDropdown() {
		if (utils.checkBP('ds', true)) {
			this.$sortDropdown.appendTo(this.$menu);
		} else {
			this.$sortDropdown.prependTo(this.$filters);
		}

		this.$sortDropdown.removeClass(CLS_HIDE);
	}

	updateParam() {
		if (this.sourceId) {
			this.params.sourceID = this.sourceId;
		}

		let lang = document.documentElement.lang;
		let appendedLangs = ['de', 'zh-hk']; // this language will be appended to vanity url

		// append language if exist on appendedLangs
		if (lang && appendedLangs.indexOf(lang.toLowerCase()) !== -1) {
			if (lang.toLowerCase() === 'zh-hk') {
				lang = 'hk';
			}

			this.urlPattern.lang = lang;
		}

		if (this.shopName) {
			this.urlPattern.shopName = this.shopName;
		}

		// get filters value
		let $filters = this.$element.find(`.${CLS}-filter`);
		_.forEach($filters, (filterObj, i) => {
			let $selectedRadio = $(filterObj).find(`.${CLS}-filter-body-item-radio[checked]`);
			let radioVal = $selectedRadio.val();
			let radioName = $selectedRadio.prop('name');
			if (!_.isNil(radioVal) && radioVal !== '') {
				this.urlPattern[radioName] = radioVal;
			}
		});

		// get dropdown value
		let $selectedDropdown = this.$dropdowns.find(`.dropdown-item.${CLS_IS_SELECTED}`);
		if ($selectedDropdown.length > 0) {
			let filterType = $selectedDropdown.closest(`.dropdown`).attr('data-filter-type');
			let filterValue = $selectedDropdown.data('filter-value');
			this.params[filterType] = filterValue;
		}
	}

	handleClearFilter() {
		this.$clearFilterBtn.on('click', () => {
			let $filters = this.$element.find(`.${CLS}-filter`);
			_.forEach($filters, (filterObj, i) => {
				$(filterObj).find(`.${CLS}-filter-body-item-radio[value="all"]`).attr('checked', true);
			});
			this.updateParam();
			this.updateUrl();
		});
	}

	updateUrl() {
		// pattern: https://www.woolmark.com/{language}/{shop-page-name}/{category}/{designer}/{productType}/{region}/?sourceID={number}&sortType={sortType}
		let uri = document.location.origin;

		Object.keys(this.urlPattern).forEach((key, index) => {
			uri += `/${this.urlPattern[key]}`;
        });

        Object.keys(this.params).forEach((key, index) => {
			if (key !== 'pageNumber') {
				uri = utils.updateQueryStringParameter(uri, key, this.params[key]);
			}
        });

		window.location.href = uri;
		// console.log(NS, uri);
	}

	initProductItemWidget() {
		// move it to utils so it can be used globally
		utils.initProductItemWidget(this.$element);
	}
}
